import AccountSummarySortableTableWidget from "../AccountSummarySortableTableWidget";
import AccountSummaryAccountCustomLinksWidget from "./components/AccountSummaryAccountCustomLinksWidget";

/**
 * @function AccountSummarySortableTableWithLinksWidget
 * @return {React.Component}
 * @exported true
 * @description An account summary widget that show custom links set through cctm.
 * It is currently a wrapper of component "AccountSummarySortableTableWidget".
 */
export default function AccountSummarySortableTableWithLinksWidget(props) {
    return (
        <>
            <AccountSummarySortableTableWidget key="accountSummary_2" 
            className="show-on-desktop custom-account-links" 
            showCustomLinks={ true } />
        </>
    );
}